module.exports = {"id":"225713","name":"Jean-Kévin Augustin","rating":"75","photo":"./data/images/photos/1/225713.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["BU","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jean-KevinAugustin0.json
// module id = 1954
// module chunks = 0